<script setup lang="ts">
defineProps({ blok: Object });

const localePath = useLocalePath();
</script>

<template>
  <section v-if="blok" class="section bg-[#FFC14A]">
    <UiContainer max-width="max-w-5xl">
      <div class="grid grid-cols-2 gap-12 items-center">
        <header
          class="[&>h3]:font-londrina-solid [&>h3]:fs-7xl [&>h3]:text-white [&>h3>strong]:text-chsc-indigo [&>h3]:mb-9 [&>p]:font-eb-garamond [&>p]:fs-2xl [&>p]:text-chsc-indigo-500 [&>p>a]:text-white! [&>p>a]:underline"
        >
          <StoryblokRichText :doc="blok?.text" />
        </header>
        <div>
          <img
            v-motion-slide-visible-once-right
            src="https://a.storyblok.com/f/291812700015950/757x856/f0461e3e68/home-work.svg"
            alt="Work"
            class="w-full"
          />
        </div>
      </div>
    </UiContainer>
  </section>
</template>
